import { DBDef_ContextRule } from '@app/hcs-shared';
import { createSearchIntegration } from '@app/styles';
import { ModuleFE_ContextRule, ModuleFE_Tag, ModuleFE_Variable } from '../../_entity.js';
import { Manager_ContextRule } from '../../ui/_managers/Manager_ContextRule/Manager_ContextRule.js';
import { Dialog_CompareRules } from '../../ui/context-rules/Dialog_CompareRules/Dialog_CompareRules.js';
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_ContextRule,
    dbDef: DBDef_ContextRule,
    tag: ['Cr', 'Context Rule'],
    modulesToAwait: [ModuleFE_ContextRule, ModuleFE_Tag, ModuleFE_Variable],
    ManagerComponent: Manager_ContextRule,
    extraMenuSections: () => [{
            actions: [{
                    label: 'Compare Context Rules',
                    action: () => Dialog_CompareRules.show(),
                }],
        }],
    resultSubtitle: (contextRule) => contextRule?.description,
});
export const WorkHubItem_ContextRule = WorkHubItem;
export const UtilObject_ContextRule = UtilObject;
export const SearchItem_ContextRule = SearchItem;
//# sourceMappingURL=context-rule.js.map